module.exports = __webpack_public_path__ + "static/important-car-8b47bb6fd06703b971cbb8fb4bee5464.png";